module.exports = __webpack_public_path__ + "sovdapp/img/footer-logo2.c6248a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-logo2.svg
// module id = /ELn
// module chunks = 1 2 3